import { apiClient } from 'clients';
import { User } from 'models';
import { handleFetchError } from 'utils/error-utils';

export interface UserByIdArgs {
  id: string;
}

export async function getUserByIdAsync(
  args: UserByIdArgs,
): Promise<User | null> {
  try {
    const { data } = await apiClient.get(`/usermanagement/users/${args.id}`);

    if (!!data) {
      const {
        userId,
        userName: username,
        firstName,
        lastName,
        agencyGroupId,
        agencyGroupName,
      } = data.data;

      return {
        id: username,
        userId,
        username,
        firstName,
        lastName,
        agency: {
          id: agencyGroupId as number,
          name: agencyGroupName,
        },
      };
    } else {
      return null;
    }
  } catch (error: any) {
    throw handleFetchError(error);
  }
}

export async function getUserAgencyGroupOptionsAsync(): Promise<any[]> {
  try {
    const {
      data: { data },
    } = await apiClient.get(`/usermanagement/persona`);
    if (!!data && data.personaOptions.length > 0) {
      return data.personaOptions.map((option: any) => ({
        id: option.agencyGroupId,
        value: `(${option.agencyGroupId}) ${option.agencyGroupName}`,
      }));
    }
  } catch (error: any) {
    return [];
  }
  return [];
}

export async function setUserAgencyGroupAsync(
  agencyGroupId: string,
): Promise<any> {
  try {
    const { data } = await apiClient.post(
      `/usermanagement/persona?agencyGroupId=${agencyGroupId}`,
    );
    return data;
  } catch (error: any) {
    return null;
  }
}
